import { countIndexedThreadsForCheckout, type CheckoutOption } from "./projectCheckoutOptions";

interface ThreadIndexedEnvironment {
  readonly threadIdsByProjectId?: Readonly<Record<string, readonly unknown[]>>;
}

export function resolveProjectGroupThreadCounts(
  environmentStateById: Readonly<Record<string, ThreadIndexedEnvironment | undefined>>,
  checkouts: readonly CheckoutOption[],
): { readonly byCheckoutValue: ReadonlyMap<string, number>; readonly total: number } {
  const byCheckoutValue = new Map(
    checkouts.map((checkout) => [
      checkout.value,
      countIndexedThreadsForCheckout(environmentStateById, checkout),
    ]),
  );
  return {
    byCheckoutValue,
    total: [...byCheckoutValue.values()].reduce((sum, count) => sum + count, 0),
  };
}
